module.exports = __webpack_public_path__ + "static/media/my-pic2.49a11c0a.jpg";